import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { isProjectScope, isReleaseGroupScope, type VulnIssue } from '../../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../../redux/issuesV2';

import GlobalStatus from './Global';
import ProjectStatus from './Project';
import { ReleaseGroupStatus } from './ReleaseGroup';

/**
 * Display the issue details status base on the project scope (project or global).
 */
const IssueDetailsStatus: VoidFunctionComponent = () => {
  const scope = useSelector(IssuesV2Store.selectors.getScope);
  const activeIssue = useSelector(IssuesV2Store.selectors.getIssueDetails) as VulnIssue;
  if (!activeIssue) {
    return null;
  }

  if (isProjectScope(scope)) {
    return <ProjectStatus />;
  }

  if (isReleaseGroupScope(scope)) {
    return <ReleaseGroupStatus />;
  }

  return <GlobalStatus />;
};

export default IssueDetailsStatus;
